import React from 'react'

const Header = () => {
    return (
        <>
         <h1>Hang Man</h1>   
         <p>Find the Hidden word - Enter a letter</p>
        </>
    )
}

export default Header
